import { createOutbox, type Outbox, type OutboxOptions } from './engine';

export type * from './types';
export type { OutboxStore } from './store';
export type { Outbox, OutboxOptions, EnqueueInput } from './engine';
export type { Registry } from './registry';
export type { Transport } from './http';
export { createOutbox, ITEM_TTL_MS, EXPIRED_MESSAGE } from './engine';
export { keyFor } from './keys';
export { classify, retryDelayMs, NOTICE_STALE, NOTICE_CONFLICT, DROP_FALLBACK } from './policy';
export { registerKind, kindRegistry, createRegistry } from './registry';
export { createHttpTransport, OutboxSendError, WrongUserError } from './http';
export { createIdbStore } from './store.idb';
export { createMemoryStore } from './store.memory';
export { kickWhenBackOnline, windowConnectivity, capacitorConnectivity } from './network';
export type { ConnectivitySource, NetworkPlugin } from './network';

let instance: Outbox | null = null;

/** The app's one outbox (one drain loop per app instance): a second call returns the first outbox, whatever its options. */
export function initOutbox(options: OutboxOptions): Outbox {
  instance ??= createOutbox(options);
  return instance;
}

/** The outbox made by `initOutbox`, or null before the app started it. */
export function getOutbox(): Outbox | null {
  return instance;
}
